import { useEffect, useState } from "react";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { STORAGE_KEYS } from "@Components/Chatbot/utils/chatbotStorage";
import { GROWTH_BOOK_FEATURE_FLAG_NAMES } from "constants/index";

const useShowSmartQuestions = () => {
  const isSmartQuestionsEnabled = useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.SMART_QUESTIONS);
  const [hasLead, setHasLead] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      try {
        const leadData = window.localStorage.getItem(STORAGE_KEYS.LEAD_FORM_DATA);
        setHasLead(!!leadData);
      } catch {
        setHasLead(false);
      }

      const handleLeadFormSaved = () => setHasLead(true);
      window.addEventListener("lead-form-saved", handleLeadFormSaved);
      return () => window.removeEventListener("lead-form-saved", handleLeadFormSaved);
    }
    return undefined;
  }, []);

  return isSmartQuestionsEnabled && hasLead;
};

export default useShowSmartQuestions;
